const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源聚合',
    desc: '汇聚20+特色视频站点，电影、电视剧、综艺、动漫、纪录片全覆盖，每日更新海量高清内容，一站式满足你的观影需求。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅播放',
    desc: '采用多线路智能切换与CDN加速技术，1080P高清画质保证，自适应带宽优化播放体验，告别缓冲等待的烦恼。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全便捷访问',
    desc: '无需注册无需登录即可免费使用，全站HTTPS加密传输保护隐私，适配电脑、平板、手机全设备畅快浏览。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
            为什么选择69视频
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 border border-background-200 text-center hover:border-primary-200 transition-all"
              >
                <span className="inline-flex w-14 h-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}